<template>
  <b-container fluid>
    <b-row style="margin-left: -30px; margin-right: -30px;">
      <div class="col-12 col-md-8">
        <a href="/" v-if="this.$store.getters.UberAgentDetails.length>0" @click.stop.prevent="downloadNonStandardLicense(0)">Download uberAgent License</a>
        <span v-if="this.$store.getters.DeviceTrustDetails.length>0" class="primary-text"> | </span>
        <a href="/" v-if="this.$store.getters.DeviceTrustDetails.length>0" @click.stop.prevent="downloadNonStandardLicense(1)">Download deviceTRUST License</a>
        <span v-if="this.$store.getters.StrongLicDetails.length>0" class="primary-text"> | </span>
        <a href="/" v-if="this.$store.getters.StrongLicDetails.length>0" @click.stop.prevent="openRegisterDomainModal()">Register Domain for Strong Network</a>
        <span v-if="this.$store.getters.UniconLicDetails.length>0" class="primary-text"> | </span>
        <a href="/" v-if="this.$store.getters.UniconLicDetails.length>0" @click.stop.prevent="openUniconCustomerModal()">Activate Unicon Customer</a>
      </div>
    </b-row>
    <b-row style="margin-left: -30px; margin-right: -30px; margin-top: 10px;">
      <div class="col-12 col-md-4">
        <p v-if="!hideQuickFind">
          {{ $t('quickFind') }}:&nbsp;
          <a href="/#/licenses"
             @click.stop.prevent="handleQuickFindLinkClick('All Active Link', 'active')">
            {{ $t('allActive') }}
          </a>
          <span class="primary-text"> | </span>
          <a href="/#/licenses"
             @click.stop.prevent="handleQuickFindLinkClick('All Archived Link', 'archived')">
            {{ $t('allArchived') }}
          </a>
        </p>
      </div>
      <div class="col-12 col-md-8 text-right">
        <b-dropdown size="sm" right text="Frequently Asked Questions" class="m-md-2">
          <b-dropdown-item id="pendo-manage-my-licenses-allocate-licenses" v-if="!hideQuickFind">How to allocate a license?</b-dropdown-item>
          <b-dropdown-item id="pendo-manage-my-licenses-reallocate-licenses" v-if="!hideQuickFind">How to re-allocate a license?</b-dropdown-item>
          <b-dropdown-item id="pendo-manage-my-licenses-download-license-file" v-if="!hideQuickFind">How to download a license?</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :href="UrlBuilder.getLicensingFaqsUrl(locale)" target="_blank">More on {{ $t('licensingFaqs') }}...</b-dropdown-item>
        </b-dropdown>
      </div>
    </b-row>
    <registerdomain-modal :modal="registerdomainModal"
                          :openModal="openRegisterdomainModal"
                          :closeModal="closeRegisterdomainModal"
                          :customHeader="customHeader" />
    <uniconcustomer-modal :modal="uniconcustomerModal"
                          :openModal="openUniconCustomerModal"
                          :closeModal="closeUniconCustomerModal"
                          :customHeader="customHeader" />
  </b-container>
</template>

<script>
  import Vue from 'vue'
  import download from 'downloadjs'
  import RegisterDomainModal from './RegisterDomainModal'
  import UniconCustomerModal from './UniconCustomerModal'

  export default {
    name: 'QuickFind',
    props: {
      page: {
        type: String,
        required: true
      },
      hideQuickFind: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'registerdomain-modal': RegisterDomainModal,
      'uniconcustomer-modal': UniconCustomerModal
    },
    data () {
      return {
        registerdomainModal: false,
        uniconcustomerModal: false
      }
    },
    computed: {
      locale () {
        const locales = {
          en: 'en-us',
          fr: 'fr-fr',
          de: 'de-de',
          es: 'es-es',
          jp: 'ja-jp',
          zh: 'zh-cn'
        }
        const userLocale = this.$store.getters.person.preferences.locale.split('-')[0]
        return locales[Object.keys(locales).includes(userLocale) ? userLocale : 'en']
      }
    },
    methods: {
      handleQuickFindLinkClick (linkType, filterName) {
        Vue.AppInsights.trackEvent(`Quick Find - ${linkType}`, {
          page: this.page
        })
        this.$emit('filterClicked', filterName)
      },
      openRegisterDomainModal () {
        this.registerdomainModal = true
      },
      downloadNonStandardLicense (nsLicTypeId) {
        this.bottle.post(this.UrlBuilder.downloadNonStandardLic(this.$store.getters.nsLicType[nsLicTypeId], this.$store.getters.person.customerId), { ...this.requestBody(this.$store.getters.nsLicType[nsLicTypeId]) }, { responseType: 'blob' })
        .then(({data, headers}) => {
          const fileName = this.getDownloadFilename(headers['content-disposition'])
          Vue.AppInsights.trackEvent('Download action', this.downloadRequestBody)
          this.isDownloading = false

          const contentType = headers['content-type']

          if (nsLicTypeId === 0 && contentType === 'application/octet-stream') {
            // Special handling for UberAgent (nsLicTypeId = 0)
            const blob = new Blob([data], { type: 'application/octet-stream' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else if (contentType === 'application/zip') {
            // Standard ZIP handling for other IDs
            const blob = new Blob([data], { type: 'application/zip' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else if (contentType === 'text/html') {
            // Text file handling for other IDs
            download(data, fileName, 'text/html')
          } else {
            console.error('Unsupported file type:', contentType)
          }
        })
        .catch((error) => {
          this.loading = false
          this.loggly.log({
            errorMessage: `Failed to download NonStandard License`,
            errorObject: error,
            errorStack: error.stack
          })
        })
      },
      getDownloadFilename (string) {
        return string.split('; ')[1].split('=')[1]
      },
      requestBody (nsLicType) {
        if (nsLicType === 'uberAgent') {
          return {
            CustomerId: this.$store.getters.person.customerId,
            ExpiryDate: new Date(this.$store.getters.UberAgentDetails[0].Expiry).toISOString().split('T')[0],
            assetComponentId: this.$store.getters.UberAgentDetails[0].AssetComponentId
          }
        } else if (nsLicType === 'deviceTrustLic') {
          return {
            CustomerId: this.$store.getters.person.customerId,
            ExpiryDate: new Date(this.$store.getters.DeviceTrustDetails[0].Expiry).toISOString().split('T')[0],
            SerialNumber: this.$store.getters.DeviceTrustDetails[0].SerialNumber,
            assetComponentId: this.$store.getters.DeviceTrustDetails[0].AssetComponentId,
            Quantity: this.$store.getters.DeviceTrustDetails[0].Quantity,
            LicenceType: null
          }
        }
      },
      closeRegisterdomainModal () {
        this.registerdomainModal = false
      },
      openRegisterdomainModal () {
        this.registerdomainModal = true
      },
      openUniconCustomerModal () {
        this.uniconcustomerModal = true
      },
      closeUniconCustomerModal () {
        this.uniconcustomerModal = false
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../styles/variables.scss';

  span {
    color: $primary;
  }
  a,
  a:hover {
    text-decoration: none;
    color: $primary;
  }
</style>



// WEBPACK FOOTER //
// src/components/QuickFind.vue